import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../rootReducer';
import { HttpMethods, SERVICES } from '../../services/api';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage } from '../notifications';
import { IAccountExtraData } from './fetchAccountExtraData.slices';

export const fetchAccountExtraData: AsyncThunk<IAccountExtraData, undefined, ThunkAPI> = createAsyncThunk(
  'account/fetchExtraData',
  async (data, thunk) => {
    try {
      return await basicApiAsyncThunkCreator<IAccountExtraData, undefined>({
        endpoint: 'crm/catalog/account/subscription',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(undefined, thunk);
    } catch (err) {
      thunk.dispatch(showErrorMessage('Your request failed, please try again later or contact support'));
      return thunk.rejectWithValue(err);
    }
  }
);
